import React, { useEffect, useState } from 'react'
import { connect, ConnectedProps } from "react-redux"
import CMSAction from 'cms/actions/common/CMSAction';
import { Dispatch } from '@reduxjs/toolkit';
import IClientLanguage from 'core/interfaces/IClientLanguage';
import IClientSiteSettingDetail from 'cms/interfaces/IClientSiteSettingDetail';
import TMenu from 'cms/types/TMenu';
import IClientMenuItemList from 'cms/interfaces/IClientMenuItemList';
import TValidations from 'cms/types/TValidations';
import MenuComposer from 'cms/utilities/MenuComposer';
import { isEmpty } from 'lodash';
import Logo from 'components/Logo';
import SocialMedia01 from 'components/SocialMedia/components/SocialMedia01';
import LanguageVersionSelector from 'cms/utilities/LanguageVersionSelector';
import ILanguageVersionList from 'cms/interfaces/ILanguageVersionList';
import { EContentType } from 'cms/enums/EContentType';
import { EViewType } from 'cms/enums/EViewType';
import { EView } from 'cms/enums/EView';
import RMDRNavLink from 'components/RMDRNavLink';


function mapStateToProps ( state: any ) {
    console.log("MobileMenu.mapStateToProps: ", state);

    const siteSettingDetailPayload:IClientSiteSettingDetail         = state.SiteSettingStore.details?.payload;

    const webApplicationLanguage:IClientLanguage   = state.CoreStore.language?.payload;
    const webApplicationLanguageCode:string        = webApplicationLanguage.code;
    const webApplicationLanguageISOCode:string     = state.CoreStore.languageCode?.payload;

    const clientMenuItemGet:IClientMenuItemList[]|null              = state.HeaderStore.ClientMenuItemStore.get?.["MNGRP001"];
    const clientMenuItemGetError:TValidations[]|null                = state.HeaderStore.ClientMenuItemStore.get?.error;
    const clientMenuItemGetIsLoading:boolean                        = state.HeaderStore.ClientMenuItemStore.get?.isLoading;

    return {

        siteSettingDetailPayload,

        webApplicationLanguage,
        webApplicationLanguageCode,
        webApplicationLanguageISOCode,

        clientMenuItemGet,
        clientMenuItemGetError,
        clientMenuItemGetIsLoading

    }
}

function mapDispatchToProps ( dispatch: Dispatch ) {
    console.log("MobileMenu.mapDispatchToProps");

    const cmsAction = new CMSAction(dispatch);

    return {
        
        _openMobileMenu: () => {
            cmsAction.openMobileMenu();
        },

        _closeMobileMenu: () => {
            cmsAction.closeMobileMenu();
        }

    }
}

const connector = connect(mapStateToProps, mapDispatchToProps);


/* types */
type PropsFromRedux = ConnectedProps<typeof connector>

type TMobileMenu<T> = {
    
    onClick: (event:React.MouseEvent<HTMLDivElement|HTMLSpanElement>, contentId:string) => void;

} & T;

type TIsActive = {
    status: boolean;
    key:any;
    subMenuKey: any
}


/* component */
function MobileMenuLoader () {

    return (
        <></>
    )

}

function MobileMenu ( props:TMobileMenu<PropsFromRedux> ) {
    console.log("MobileMenu.rendered: ", props);

    const [ navigation, setNavigation ] = useState<TMenu[]|null>(null);
    const [isActive, setIsActive] = useState<TIsActive>({status: false, key:null, subMenuKey: null });

    useEffect(
        () => {

            if ( !isEmpty(props.clientMenuItemGet) ) {
                let parentMenuItems = props.clientMenuItemGet?.filter((item:any) => item.parentId === null);
                let navigation = MenuComposer(props.clientMenuItemGet, parentMenuItems);
                setNavigation(navigation);
            }

        }, [ props.clientMenuItemGet ]
    )

    function handleToggle ( key:string, subMenuKey:string|null = null) {
        if (isActive.key === key && isActive.subMenuKey === subMenuKey) {
          setIsActive({ status: false, key: null, subMenuKey: null });
        } else {
          setIsActive({ status: true, key, subMenuKey });
        }
    }
    
    return (
        <div className="mobile-nav__wrapper">
            <div className="mobile-nav__overlay mobile-nav__toggler" onClick={(event:any) => { props.onClick(event, "") }} ></div>
            <div className="mobile-nav__content rmdr-scroll-1">
                <span className="mobile-nav__close mobile-nav__toggler" onClick={(event:any) => { props.onClick(event, "") }} ><i className="fa fa-times"></i></span>

                <div className="logo-box">
                    <Logo 
                        siteSettingPayload={props.siteSettingDetailPayload} 
                        webApplicationLanguageISOCode={props.webApplicationLanguageISOCode} 
                    />
                </div>

                <div className="mobile-nav__container">
                    <div className="collapse navbar-collapse show clearfix" id="navbarSupportedContent">
                        <ul className="main-menu__list">
                            {
                                navigation?.map((item, index) => {
                                    const languageVersion = LanguageVersionSelector<ILanguageVersionList>({
                                        languageVersions: item.languageVersions,
                                        filters:[{ view: EView.OUTTER, viewType: EViewType.NAME_DESCRIPTION, contentType: EContentType.DEFAULT }],
                                        type: "find"
                                    });

                                    const redirectUrl = LanguageVersionSelector<ILanguageVersionList>({
                                        languageVersions: item.languageVersions,
                                        filters:[{ view: EView.META_DATA, viewType: EViewType.TEXT, contentType: EContentType.DEFAULT, name: "redirectUrl" }],
                                        type: "find"
                                    });

                                    return (
                                        <li key={item.id} className={`${item?.items && item.items?.length > 0 ? "dropdown" : ""} ${isActive.key === item.id ? "current" : ""}`}>
                                            <RMDRNavLink
                                                text={languageVersion?.name}
                                                title={languageVersion?.name}
                                                navigationURL={languageVersion.contentRouteNavigationURL}
                                                hasNavigationDestination={item.hasDestinationNavigation}
                                                isShowAlways={true}
                
                                                redirectType={item.redirectType}
                                                redirectUrl={redirectUrl?.value}
                                                onClick={(event:any) => { props.onClick(event, item.id) }}
                                                variant='div'
                                            />
                                            {
                                                item?.items && item.items?.length > 0 ? 
                                                    (
                                                        <>
                                                            <ul className={`${isActive.key === item.id ? "!tw-block" : "!tw-hidden"}`}>
                                                                {
                                                                    item.items.map((cItem) => {
                                                                        const cLanguageVersion = LanguageVersionSelector<ILanguageVersionList>({
                                                                            languageVersions: cItem.languageVersions,
                                                                            filters:[{ view: EView.OUTTER, viewType: EViewType.NAME_DESCRIPTION, contentType: EContentType.DEFAULT }],
                                                                            type: "find"
                                                                        });
                                                
                                                                        const cRedirectUrl = LanguageVersionSelector<ILanguageVersionList>({
                                                                            languageVersions: cItem.languageVersions,
                                                                            filters:[{ view: EView.META_DATA, viewType: EViewType.TEXT, contentType: EContentType.DEFAULT, name: "redirectUrl" }],
                                                                            type: "find"
                                                                        });

                                                                        return (
                                                                            <li key={item.id}>
                                                                                <RMDRNavLink
                                                                                    title={cLanguageVersion?.name}
                                                                                    text={cLanguageVersion?.name}
                                                                                    navigationURL={cLanguageVersion.contentRouteNavigationURL}
                                                                                    hasNavigationDestination={cItem.hasDestinationNavigation}
                                                                                    isShowAlways={true}
                                                    
                                                                                    redirectType={cItem.redirectType}
                                                                                    redirectUrl={cRedirectUrl?.value}
                                                                                    onClick={(event:any) => { props.onClick(event, cItem.id) }}
                                                                                    variant='div'
                                                                                />
                                                                            </li>
                                                                        )
                                                                    })
                                                                }
                                                            </ul>
                                                            
                                                            <button className={isActive.key === item.id ? "expanded open" : ""} onClick={() => handleToggle(item.id)}><span className="fa fa-angle-right" /></button>
                                                        </>
                                                    ) : null
                                            }
                                        </li>
                                    );
                                })
                            }
                        </ul>
                    </div>
                </div>
                <div className="mobile-nav__top">
                    <SocialMedia01
                        payload={props.siteSettingDetailPayload.languageVersions}
                        className="mobile-nav__social mt-5 tw-w-full tw-justify-center"
                        iconClassName='tw-w-5 tw-h-5'
                    />
                </div>
            </div>
        </div>
    );
}




const Component = React.memo(MobileMenu, ( prevProps:TMobileMenu<PropsFromRedux>, nextProps:TMobileMenu<PropsFromRedux> ) => {
    return false;
});

export default connector(Component);
